import type { AnchorHTMLAttributes, HTMLAttributes, ReactElement } from "react";
import { cn } from "@/shared/utils/cn";

export interface NavigationListProps extends HTMLAttributes<HTMLElement> {
  label: string;
}

export function NavigationList({
  label,
  className,
  children,
  ...props
}: NavigationListProps): ReactElement {
  return (
    <nav aria-label={label} className={cn("flex flex-col gap-1", className)} {...props}>
      {children}
    </nav>
  );
}

export interface NavigationItemProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  active?: boolean;
}

export function NavigationItem({
  active = false,
  className,
  children,
  ...props
}: NavigationItemProps): ReactElement {
  return (
    <a
      className={cn(
        "flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium no-underline transition-colors",
        active
          ? "bg-clm-primary-blue text-white"
          : "text-foreground hover:bg-muted hover:text-clm-primary-blue",
        className,
      )}
      aria-current={active ? "page" : undefined}
      {...props}
    >
      {children}
    </a>
  );
}
